<script setup lang="ts">
import { Loader2 } from 'lucide-vue-next'
import type { HTMLAttributes } from 'vue'
import { cn } from '@/ui/lib/utils'

const props = withDefaults(defineProps<{ size?: 'sm' | 'default' | 'lg'; class?: HTMLAttributes['class'] }>(), {
  size: 'default'
})

const sizeClass = {
  sm: 'size-4',
  default: 'size-5',
  lg: 'size-6'
} as const
</script>

<template>
  <Loader2
    :class="cn('animate-spin text-muted-foreground', sizeClass[props.size], props.class)"
    aria-label="Loading"
    role="status"
  />
</template>
